import { render, staticRenderFns } from "./ProductGiro.vue?vue&type=template&id=2d266c72"
import script from "./ProductGiro.vue?vue&type=script&lang=js"
export * from "./ProductGiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports